import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    closeHotSpotModal,
    openHotSpotModal,
    changeHotSpotField,
} from './hot-spot-modal.state';


export const withHotSpotsModal = connect(
    state => ({
        hotSpotModal: state.dashboard.hotSpotModal,
        objectSelected: state.data.objectSelected,
    }),
    dispatch => bindActionCreators({
        openHotSpotModal,
        closeHotSpotModal,
        changeHotSpotField,
    }, dispatch),
);
